// extracted by mini-css-extract-plugin
export default {"formContainer":"SubProgramPreferences_formContainer__B1Ob0","inputWrapper":"SubProgramPreferences_inputWrapper__VkI6n","title":"SubProgramPreferences_title__u-eDL"};